import * as Types from "../../../apollo/graphql.generated";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {};
export type ContractFieldsFragment = {
  __typename: "Contract2";
  id: string;
  chainId: number;
  contractType: Types.ContractEntityType;
  name: string;
  address: string | null;
  symbol: string;
  contractUri: string | null;
  createdAt: string | null;
};

export type GetContractsByUserQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetContractsByUserQuery = {
  getContractsByUser: Array<{
    __typename: "Contract2";
    id: string;
    chainId: number;
    contractType: Types.ContractEntityType;
    name: string;
    address: string | null;
    symbol: string;
    contractUri: string | null;
    createdAt: string | null;
  }>;
};

export type CreateContractMutationVariables = Types.Exact<{
  createContractData: Types.CreateContractInput;
}>;

export type CreateContractMutation = {
  createContract: {
    __typename: "Contract2";
    id: string;
    chainId: number;
    contractType: Types.ContractEntityType;
    name: string;
    address: string | null;
    symbol: string;
    contractUri: string | null;
    createdAt: string | null;
  };
};

export type UpdateContractMutationVariables = Types.Exact<{
  contractId: Types.Scalars["String"];
  updateContractData: Types.UpdateContractInput;
}>;

export type UpdateContractMutation = {
  updateContract: {
    __typename: "Contract2";
    id: string;
    chainId: number;
    contractType: Types.ContractEntityType;
    name: string;
    address: string | null;
    symbol: string;
    contractUri: string | null;
    createdAt: string | null;
  };
};

export const ContractFieldsFragmentDoc = gql`
  fragment ContractFields on Contract2 {
    id
    chainId
    contractType
    name
    address
    symbol
    contractUri
    createdAt
  }
`;
export const GetContractsByUserDocument = gql`
  query GetContractsByUser {
    getContractsByUser {
      ...ContractFields
    }
  }
  ${ContractFieldsFragmentDoc}
`;

/**
 * __useGetContractsByUserQuery__
 *
 * To run a query within a React component, call `useGetContractsByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractsByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractsByUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContractsByUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetContractsByUserQuery,
    GetContractsByUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetContractsByUserQuery,
    GetContractsByUserQueryVariables
  >(GetContractsByUserDocument, options);
}
export function useGetContractsByUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetContractsByUserQuery,
    GetContractsByUserQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetContractsByUserQuery,
    GetContractsByUserQueryVariables
  >(GetContractsByUserDocument, options);
}
export type GetContractsByUserQueryHookResult = ReturnType<
  typeof useGetContractsByUserQuery
>;
export type GetContractsByUserLazyQueryHookResult = ReturnType<
  typeof useGetContractsByUserLazyQuery
>;
export type GetContractsByUserQueryResult = Apollo.QueryResult<
  GetContractsByUserQuery,
  GetContractsByUserQueryVariables
>;
export const CreateContractDocument = gql`
  mutation CreateContract($createContractData: CreateContractInput!) {
    createContract(data: $createContractData) {
      ...ContractFields
    }
  }
  ${ContractFieldsFragmentDoc}
`;
export type CreateContractMutationFn = Apollo.MutationFunction<
  CreateContractMutation,
  CreateContractMutationVariables
>;

/**
 * __useCreateContractMutation__
 *
 * To run a mutation, you first call `useCreateContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContractMutation, { data, loading, error }] = useCreateContractMutation({
 *   variables: {
 *      createContractData: // value for 'createContractData'
 *   },
 * });
 */
export function useCreateContractMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateContractMutation,
    CreateContractMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateContractMutation,
    CreateContractMutationVariables
  >(CreateContractDocument, options);
}
export type CreateContractMutationHookResult = ReturnType<
  typeof useCreateContractMutation
>;
export type CreateContractMutationResult =
  Apollo.MutationResult<CreateContractMutation>;
export type CreateContractMutationOptions = Apollo.BaseMutationOptions<
  CreateContractMutation,
  CreateContractMutationVariables
>;
export const UpdateContractDocument = gql`
  mutation UpdateContract(
    $contractId: String!
    $updateContractData: UpdateContractInput!
  ) {
    updateContract(contractId: $contractId, data: $updateContractData) {
      ...ContractFields
    }
  }
  ${ContractFieldsFragmentDoc}
`;
export type UpdateContractMutationFn = Apollo.MutationFunction<
  UpdateContractMutation,
  UpdateContractMutationVariables
>;

/**
 * __useUpdateContractMutation__
 *
 * To run a mutation, you first call `useUpdateContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractMutation, { data, loading, error }] = useUpdateContractMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      updateContractData: // value for 'updateContractData'
 *   },
 * });
 */
export function useUpdateContractMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateContractMutation,
    UpdateContractMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateContractMutation,
    UpdateContractMutationVariables
  >(UpdateContractDocument, options);
}
export type UpdateContractMutationHookResult = ReturnType<
  typeof useUpdateContractMutation
>;
export type UpdateContractMutationResult =
  Apollo.MutationResult<UpdateContractMutation>;
export type UpdateContractMutationOptions = Apollo.BaseMutationOptions<
  UpdateContractMutation,
  UpdateContractMutationVariables
>;
